<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Patterns />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Patterns from "../../components/GestionEmpleados/Views/Employee/Patterns.vue";
export default {
  components: { LandingToolbar, Patterns },
};
</script>
